/* Loyal Canvas — keep the free-shipping bar live as the cart changes.
 * Listens for Horizon/Shopify cart updates and re-fetches /cart.js to update the
 * "you're $X away" message + the progress fill, without a page reload. Honest:
 * the threshold + remaining are computed from the real cart total. */
(function () {
  "use strict";
  var THRESHOLD = 7500; // cents — mirrors the real US free-ship rule ($75)

  function money(cents) {
    // Minimal $ formatter; Shopify's money format is applied server-side on
    // first paint — this keeps the live update consistent for USD.
    return "$" + (cents / 100).toFixed(2);
  }

  function update(total) {
    var bars = document.querySelectorAll(".lc-ship");
    bars.forEach(function (bar) {
      var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
      var fill = bar.querySelector(".lc-ship-fill");
      var msg = bar.querySelector(".lc-ship-msg");
      if (fill) fill.style.width = pct + "%";
      if (!msg) return;
      if (total >= THRESHOLD) {
        msg.className = "lc-ship-msg lc-ship-won";
        msg.innerHTML = "🎉 You’ve unlocked <strong>free US shipping</strong>.";
      } else {
        msg.className = "lc-ship-msg";
        msg.innerHTML = "You’re <strong class=\"lc-ship-amt\">" + money(THRESHOLD - total) + "</strong> away from <strong>free US shipping</strong>.";
      }
    });
  }

  function refresh() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.total_price === "number") update(c.total_price); })
      .catch(function () {});
  }

  // Horizon dispatches cart events; also patch fetch to catch /cart/add|change|update.
  document.addEventListener("cart:updated", refresh);
  document.addEventListener("cart:refresh", refresh);
  document.addEventListener("variant:add", refresh);

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var url = arguments[0];
      var p = _fetch.apply(this, arguments);
      try {
        var u = (typeof url === "string") ? url : (url && url.url) || "";
        if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refresh, 60); });
      } catch (e) {}
      return p;
    };
  }
})();
